<div class="sow-modal" data-testid="sow-modal">
  <!-- Title bar -->
  <div class="sow-modal__title-bar">
    <h3 class="sow-modal__title-bar-text">Quote PDF</h3>
    <button
      type="button"
      class="sow-modal__close-x"
      data-testid="sow-modal-close-btn"
      aria-label="Close"
      (click)="close()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M6.36436 19.0588L4.96436 17.6588L10.5644 12.0588L4.96436 6.45884L6.36436 5.05884L11.9644 10.6588L17.5644 5.05884L18.9644 6.45884L13.3644 12.0588L18.9644 17.6588L17.5644 19.0588L11.9644 13.4588L6.36436 19.0588Z"
          fill="white"
        />
      </svg>
    </button>
  </div>
  <div class="sow-modal__content-area">
    @if (loading()) {
      <div class="sow-modal__spinner-overlay">
        <app-spinner [display]="true" [diameter]="60"></app-spinner>
      </div>
    }
    <!-- Download link -->
    <div class="sow-modal__download-row">
      <button
        type="button"
        class="sow-modal__download-link"
        data-testid="sow-modal-download-btn"
        (click)="download()"
        [disabled]="loading()"
      >
        Download Quote
      </button>
    </div>
    <mat-dialog-content class="sow-modal__body">
      <div #pdfContent>
        <!-- AZ TRANSLATE + Logo header -->
        <div class="sow-modal__brand-row">
          <span class="sow-modal__brand">AZ Translate</span>
          <img
            src="/assets/images/az-logo.svg"
            alt="AstraZeneca logo"
            class="sow-modal__logo"
          />
        </div>

        <!-- SoW title + vendor address -->
        <div class="sow-modal__sow-row">
          <div>
            <h3 class="sow-modal__sow-title">Statement of Work</h3>
            <p class="sow-modal__sow-subtitle">
              SoW creation date: {{ sowCreationDate() }}
            </p>
          </div>
          <div class="sow-modal__vendor-block">
            <p class="sow-modal__vendor-name-right">{{ vendorName() }}</p>
            @if (vendorAddress(); as addr) {
              <p class="sow-modal__vendor-detail">{{ vendorLegalName() }}</p>
              @if (addr.address1) {
                <p class="sow-modal__vendor-detail">{{ addr.address1 }}</p>
              }
              @if (addr.address2) {
                <p class="sow-modal__vendor-detail">{{ addr.address2 }}</p>
              }
              @if (addr.city) {
                <p class="sow-modal__vendor-detail">{{ addr.city }}</p>
              }
              @if (addr.zipcode) {
                <p class="sow-modal__vendor-detail">{{ addr.zipcode }}</p>
              }
              @if (addr.country) {
                <p class="sow-modal__vendor-detail">{{ addr.country }}</p>
              }
            }
          </div>
        </div>

        <!-- Language direction -->
        @if (languageDirection()) {
          <p class="sow-modal__language">{{ languageDirection() }}</p>
        }

        <!-- Job info table -->
        <table class="sow-modal__info-table" aria-label="Job information">
          <thead class="visually-hidden">
            <tr>
              <th scope="col">Field</th>
              <th scope="col">Value</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="sow-modal__info-label">Job Name</td>
              <td class="sow-modal__info-value">{{ jobName() }}</td>
            </tr>
            <tr>
              <td class="sow-modal__info-label">Job Number</td>
              <td class="sow-modal__info-value">{{ jobNumber() }}</td>
            </tr>
            <tr>
              <td class="sow-modal__info-label">Preferred delivery date</td>
              <td class="sow-modal__info-value">
                {{ preferredDeliveryDate() }}
              </td>
            </tr>
            <tr>
              <td class="sow-modal__info-label">Delivery type</td>
              <td
                class="sow-modal__info-value"
                data-testid="quote-sow-delivery-type"
              >
                {{ selectedDeliveryTypeLabel() }}
              </td>
            </tr>
            <tr>
              <td class="sow-modal__info-label">Supplier</td>
              <td class="sow-modal__info-value">{{ supplierName() }}</td>
            </tr>
            <tr>
              <td class="sow-modal__info-label">Contact</td>
              <td class="sow-modal__info-value">{{ contactEmail() }}</td>
            </tr>
          </tbody>
        </table>

        <!-- Cost breakdown -->
        <table class="sow-modal__cost-table" aria-label="Cost breakdown">
          <thead>
            <tr>
              <th class="sow-modal__cost-header">Description</th>
              <th class="sow-modal__cost-header sow-modal__cost-header--right">
                Price
              </th>
            </tr>
          </thead>
          <tbody>
            @for (item of costs(); track item.concept) {
              <tr class="sow-modal__cost-row">
                <td class="sow-modal__cost-desc">{{ item.concept }}</td>
                <td class="sow-modal__cost-price">
                  {{ item.cost | formatCurrency: currency() }}
                </td>
              </tr>
            }
          </tbody>
        </table>

        <!-- Total -->
        <div class="sow-modal__total-row">
          <div class="sow-modal__total-inner">
            <span class="sow-modal__total-label">Total</span>
            <span
              class="sow-modal__total-value"
              data-testid="quote-sow-total-cost"
              >{{ totalCost() | formatCurrency: currency() }}</span
            >
          </div>
        </div>

        <!-- Delivery message -->
        <p class="sow-modal__delivery-message">
          The project delivery date is set to
          <strong>{{ deliveryDays() }} business days</strong>
          from the PO submission in the AZ Translate portal. The expiration date
          of this SoW is 30 days from the SoW creation date.
        </p>
      </div>

      <!-- Breakdown tables -->
      @for (entry of sortedEstimateEntries(); track entry[0]) {
        <div class="sow-modal__breakdown-section" #breakdownTableEl>
          <hr class="sow-modal__separator" data-html2canvas-ignore="true" />

          <!-- AZ TRANSLATE + Logo header -->
          <div class="sow-modal__brand-row">
            <span class="sow-modal__brand">AZ Translate</span>
            <img
              src="/assets/images/az-logo.svg"
              alt="AstraZeneca logo"
              class="sow-modal__logo"
            />
          </div>

          <!-- Project info -->
          <div class="sow-modal__breakdown-header-row">
            <div>
              <h3 class="sow-modal__sow-title">Project Name</h3>
              <p class="sow-modal__breakdown-project">{{ projectName() }}</p>
              @if (smartlingJobName()) {
                <p class="sow-modal__breakdown-job">
                  <strong>Job Name</strong> {{ smartlingJobName() }}
                </p>
              }
            </div>
            <p class="sow-modal__vendor-name-right">{{ vendorName() }}</p>
          </div>

          <!-- Language direction -->
          <p class="sow-modal__breakdown-language">
            {{ getLanguageName(sourceLocale()) }} &#8594;
            {{ getLanguageName(entry[0]) }}
          </p>

          <!-- Breakdown table -->
          <div class="sow-modal__breakdown-grid">
            @for (col of breakdownCols; track col) {
              <ul class="sow-modal__breakdown-col">
                <li class="sow-modal__breakdown-col-header">{{ col }}</li>
                @for (row of entry[1]; track $index; let isLast = $last) {
                  <li
                    class="sow-modal__breakdown-col-value"
                    [class.sow-modal__breakdown-col-value--right]="
                      isNumericCol(col) || isSubtotalRow(row, isLast)
                    "
                    [class.sow-modal__breakdown-col-value--bold]="
                      isSubtotalRow(row, isLast)
                    "
                  >
                    {{ getCellValue(row, col, isLast) }}
                  </li>
                }
              </ul>
            }
          </div>
        </div>
      }

      <!-- Disclaimer -->
      @if (disclaimer()) {
        <div class="sow-modal__disclaimer-section" #disclaimerEl>
          <hr class="sow-modal__separator" data-html2canvas-ignore="true" />

          <!-- AZ TRANSLATE + Logo header -->
          <div class="sow-modal__brand-row">
            <span class="sow-modal__brand">AZ Translate</span>
            <img
              src="/assets/images/az-logo.svg"
              alt="AstraZeneca logo"
              class="sow-modal__logo"
            />
          </div>

          <div
            class="sow-modal__disclaimer-text"
            [innerHTML]="disclaimer()"
          ></div>
        </div>
      }
    </mat-dialog-content>
  </div>
</div>
